import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ComPromoterCategoryModel } from 'src/app/model/com-promoter-category.model';
import { ComPromoterCategoryService } from 'src/app/services/com-promoter-category.service';
import { CatCategoryPromoterService } from 'src/app/services/cat-category-promoter.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalCommissionPromoterCategoryComponent } from 'src/app/shared/modal-commission-promoter-category/modal-commission-promoter-category.component';

@Component({
  selector: 'app-commission-promoter-category',
  templateUrl: './commission-promoter-category.component.html',
  styleUrls: ['./commission-promoter-category.component.css']
})
export class CommissionPromoterCategoryComponent implements OnInit {
  // estado pagina
  public viewStatus = 0;  // -1:error, 0:spinner, 1:tabla
  public promoterCategories: ComPromoterCategoryModel[] = [];
  public promoterCategoryList: any[] = [];
  public employeeJobList: any[] = [];

  // opciones datatables
  dtOptions = {
    order: [],
    responsive: true,
    columnDefs: [
      { responsivePriority: 1, width: 100, targets: -1 }
    ],
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth: false,
    paging: true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private creator: CreatorService,
    private modalService: NgbModal,
    private comPromoterCategoryService: ComPromoterCategoryService,
    private catCategoryPromoterService: CatCategoryPromoterService,
    private catEmployeeJobService: CatEmployeeJobService,
    private toastr: ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  add = () => {
    let entity = this.creator.newComPromoterCategoryModel();
    let modalRef = this.modalService.open(ModalCommissionPromoterCategoryComponent, { centered: true, backdrop: 'static', keyboard: false, windowClass: 'dark-modal' });
    modalRef.componentInstance.entity = { ...entity };
    modalRef.componentInstance.promoterCategories = this.promoterCategoryList;
    modalRef.componentInstance.employeeJobs = this.employeeJobList;
    modalRef.componentInstance.mode = 'create';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getCatalogs();
      }
    );
  }
  edit = (entity: ComPromoterCategoryModel) => {
    let modalRef = this.modalService.open(ModalCommissionPromoterCategoryComponent, { centered: true, backdrop: 'static', keyboard: false, windowClass: 'dark-modal' });
    modalRef.componentInstance.entity = { ...entity };
    modalRef.componentInstance.promoterCategories = this.promoterCategoryList;
    modalRef.componentInstance.employeeJobs = this.employeeJobList;
    modalRef.componentInstance.mode = 'edit';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getCatalogs();
      }
    );
  }

  // INFO
  getCatalogs = () => {
    forkJoin([
      this.comPromoterCategoryService.getAll(),
      this.catCategoryPromoterService.getAll(),
      this.catEmployeeJobService.getAll()
    ])
    .pipe(
      tap((resp: any[]) => {
        this.promoterCategories = resp[0].data || [];
        this.promoterCategoryList = resp[1].data || [];
        this.employeeJobList = resp[2].data || [];
        this.viewStatus = 1;
      }),
      catchError(error => {
        this.viewStatus = -1;
        return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
      })
    )
    .subscribe();
  }

  // HELPERS
  getPromoterCategoryName = (id: number): string => {
    const item = this.promoterCategoryList.find(x => x.promoterCategoryId === id);
    return item ? item.description : '-';
  }
  getEmployeeJobName = (id: number): string => {
    const item = this.employeeJobList.find(x => x.employeeJobId === id);
    return item ? item.description : '-';
  }
}
